import { _ } from "../polyglot/polyglot.js";
import dialog from "./dialog.js";
import userInfoFormWidget from "./settings/userInfoFormWidget.js";

/**
 * `userInfoDialog` displays an information popup about a user,
 * as well as a button to remove the user.
 *
 * @param {{}} spec - Parameter object
 * @param {user} spec.user - User to show
 * @param {{}} my - protected fields holder
 * @return {*} userInfoDialog
 */
function userInfoDialog(spec, my) {
	spec ||= {};
	my ||= {};

	const that = dialog(spec, my);

	const user = spec.user;
	const canRemove = spec.canRemove;
	const company = spec.company;
	const userInfo = userInfoFormWidget({
		user,
		company,
	});

	that.onRemoveUser = my.events.createEvent();

	my.title = user.getName();

	my.content = function (html) {
		html.render(userInfo);
	};

	my.footer = function (html) {
		if (canRemove) {
			renderFooterWithDelete(html);
		} else {
			renderFooterWithoutDelete(html);
		}
	};

	function renderFooterWithDelete(html) {
		html.ul(
			{ class: "list-inline pull-right" },
			html.li(
				html
					.button({ klass: "btn btn-danger" }, _("Delete"))
					.click(() => {
						that.hide();
						that.onRemoveUser.trigger(user);
					}),
			),
			html.li(
				html
					.button({ klass: "btn primary" }, _("Cancel"))
					.click(that.hide),
			),
		);
	}

	function renderFooterWithoutDelete(html) {
		html.ul(
			{ class: "list-inline pull-right" },
			html.li(
				html
					.button({ klass: "btn primary" }, _("Close"))
					.click(that.hide),
			),
		);
	}

	return that;
}

export default userInfoDialog;
